(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aubest-featured-slideshow"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('aubest-featured-slideshow')){
    customElements.define('aubest-featured-slideshow',class extends HTMLElement{
      connectedCallback(){
        if(this.ready)return;this.ready=true;
        this.track=this.querySelector('.aubest-slides__track');this.slides=[...this.querySelectorAll('.aubest-slides__slide')];this.buttons=[...this.querySelectorAll('[data-slide]')];this.index=0;
        if(this.slides.length<2){this.track.removeAttribute('tabindex');return;}
        this.querySelector('.aubest-slides__controls').hidden=false;
        this.buttons.forEach(button=>button.addEventListener('click',()=>this.show(Number(button.dataset.slide))));
        this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>this.show(this.index+Number(button.dataset.direction))));
        this.track.addEventListener('scroll',()=>{const next=Math.round(this.track.scrollLeft/this.track.clientWidth);if(next!==this.index){this.index=next;this.update();}},{passive:true});
        this.track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.show(this.index+(event.key==='ArrowRight'?1:-1));}});
        this.update();
        this.resizeObserver=new ResizeObserver(()=>{this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:'instant'});});this.resizeObserver.observe(this.track);
        this.editorHandler=event=>{const i=this.slides.findIndex(slide=>slide===event.target||slide.contains(event.target));if(i>=0)this.show(i);};this.addEventListener('shopify:block:select',this.editorHandler);
      }
      show(index){this.index=(index+this.slides.length)%this.slides.length;this.update();this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
      update(){this.buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===this.index)));this.slides.forEach((slide,i)=>{slide.inert=i!==this.index;slide.setAttribute('aria-hidden',String(i!==this.index));});}
      disconnectedCallback(){if(this.resizeObserver)this.resizeObserver.disconnect();this.removeEventListener('shopify:block:select',this.editorHandler);this.ready=false;}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aubest-tracking"]) return;
  try {
    
 document.addEventListener('submit',function(event){
   if(!event.target.matches('.aubest-tracking-form'))return;
   const input=event.target.querySelector('[name="nums"]');
   const number=input.value.trim().replace(/\s+/g,'');
   if(!/^[a-zA-Z0-9-]{5,100}$/.test(number)){
     event.preventDefault();input.setCustomValidity('Enter one tracking number using letters and numbers, not your order number.');input.reportValidity();return;
   }
   event.preventDefault();input.setCustomValidity('');
   window.location.assign('https://t.17track.net/en#nums='+encodeURIComponent(number));
 });
 document.addEventListener('input',function(event){if(event.target.matches('.aubest-tracking-form input'))event.target.setCustomValidity('');});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
